import { render } from "./PaymentScreen.vue?vue&type=template&id=49a492a5&scoped=true&ts=true"
import script from "./PaymentScreen.vue?vue&type=script&lang=ts"
export * from "./PaymentScreen.vue?vue&type=script&lang=ts"

import "./PaymentScreen.vue?vue&type=style&index=0&id=49a492a5&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a492a5"]])

export default __exports__